import { Trans, useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import {
  FilterItemNoResults,
  FiltersMenu,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconStep from '@/icons/Step.svg';
import { ARTICLE_DISPLAYED_STEPS } from '@/models/article';

import { useFilters } from '../FiltersState';
import { useStepOptions } from '../utils';

export const FiltersStep = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    displayedSteps: { displayedSteps, setDisplayedSteps },
  } = useFilters();

  const stepOptions = useStepOptions();

  const options =
    stepOptions.length > 0 ? (
      stepOptions.map(({ id, name }) => (
        <FilterCheckboxItem
          key={id}
          checked={displayedSteps.includes(id)}
          onChange={(checked) => {
            if (checked) {
              setDisplayedSteps([...displayedSteps, id]);
            } else {
              setDisplayedSteps(displayedSteps.filter((step) => step !== id));
            }
          }}
        >
          {i18n._(name)}
        </FilterCheckboxItem>
      ))
    ) : (
      <FilterItemNoResults />
    );

  if (tag) {
    if (displayedSteps.length === 0) {
      return null;
    }

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({ id: 'requests.filters.step.label', message: 'Step' })}
            value={
              displayedSteps.length === 1 ? (
                i18n._(ARTICLE_DISPLAYED_STEPS.find((step) => step.id === displayedSteps[0])!.name)
              ) : (
                <Trans id="requests.filters.step.multiple">{displayedSteps.length} steps</Trans>
              )
            }
            tooltip={
              displayedSteps.length > 1
                ? displayedSteps
                    .map((step) => i18n._(ARTICLE_DISPLAYED_STEPS.find((t) => t.id === step)!.name))
                    .join(', ')
                : undefined
            }
            onClear={() => setDisplayedSteps([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconStep />}
      label={t({ id: 'requests.filters.step.label', message: 'Step' })}
    >
      {options}
    </FiltersSubMenu>
  );
};
